import React from "react";
import {Alert, Box} from "@emburse/ui-core";
import {useTranslation} from "react-i18next";

export const ConfigurationError: React.FC = () => {
    const {t} = useTranslation();

    const configurationErrorSx = {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        p: 6
    };

    return (
        <Box sx={configurationErrorSx}>
            <Alert data-qa="configuration-error-message" severity="error">
                {t("fetchConfigurationErrorMessage")}
            </Alert>
        </Box>
    );
};